import {Customer} from '../providers/customer/types';
import { atom } from 'recoil';
import { localStorageEffect } from './effects/localStorageEffect';

export const CUSTOMER_KEY = 'CUSTOMER';

export const CustomerAtom = atom<Customer| undefined>({
  key: CUSTOMER_KEY,
  default: undefined,
  effects: [localStorageEffect(CUSTOMER_KEY)],
});